const localizationLabels = {
	// English
	en: {
		appointmentType: {
			dropdownTitle: 'Choose appointment type',
			listTitle: 'How long do you need?'
		},
		timeZoneTitle: 'What time works best for you?',
		bookingView: {
			hintTexts: {
				name: 'Your name, will be on the calendar invite',
				email: 'You will receive a calendar invite on this address',
				cell: 'You will receive a booking confirmation on this number',
				payment: "Payments are processed securely by Stripe.com",
				location: "Choose where you would like to meet at the scheduled time",
				customLocation: "Type in the location for the meeting",
				locationPhoneNumber: "Type in the mobile number for meeting"
			},
			labelTexts: {
				name: "Name",
				email: "Email",
				cell: "Mobile number",
				payment: "Payment details",
				location: "Meeting Location",
				customLocation: "Location"
			},
			buttons: {
				back: "Go back",
				submit: "Submit",
				pay: "Pay"
			}
		},
		calendarView: {
			changeService: "change",
			noAvailability: "No Availability",
			noSlotForAppointment: "No slot available for this appointment. Try a different appointment from the options on the top or select a different day.",
			noSlotForDay: "No availability on this day. Try a different day from the calendar on the left."
		},
		confirmationView: {
			success: "Success",
			defaultMessage: "You'll receive a confirmation email soon"
		},
		minutes: "minutes",
		cellFieldPlaceholder: "Enter a valid mobile number",
		alertMessages: {
			requiredWarning: "Please fill all required items.",
			phoneRequiredMessage: "Mobile number is required, please type in a valid mobile number.",
			attachmentRequired: "Please upload required attachment.",
			answerRequired: "Answer is required, please type in a correct value.",
			singleAttachment: "Please choose single attachment.",
			attachmentSize: "Attachment size must be less than 10 megabytes.",
			emptyAttachmentFile: "Attachment file is empty. Please choose correct file.",
			paymentError: "Error processing payment. Try again or contact support.",
			savingBookingError: "Something went wrong, please try again.."
		},
		inputFieldErrorMessages: {
			name: "The Name field is required",
			email: "The Email field must be a valid email",
			cellNumber: "Enter a valid mobile number",
			location: "Custom Location field is required"
		}
	},
	// French
	fr: {
		appointmentType: {
			dropdownTitle: 'Choisissez le type de rendez-vous',
			listTitle: 'Combien de temps avez-vous besoin?'
		},
		timeZoneTitle: 'Quelle heure vous convient le mieux?',
		bookingView: {
			hintTexts: {
				name: "Votre nom figurera sur l'invitation du calendrier",
				email: "Vous recevrez une invitation d'agenda à cette adresse.",
				cell: "Vous recevrez une confirmation de réservation sur ce numéro de portable.",
				payment: "Fournissez vos informations de paiement pour payer en toute sécurité",
				location: "Où vous voulez vous rencontrer à l'heure prévue",
				customLocation: "Entrez n'importe quel emplacement personnalisé pour la réunion",
				locationPhoneNumber:"Tapez le numéro de téléphone pour la réunion" 
			},
			labelTexts: {
				name: "Nom",
				email: "Email",
				cell: "Téléphone portable",
				payment: "Informations de paiement",
				location: "Lieu de la réunion",
				customLocation: "Emplacement personnalisé"
			},
			buttons: {
				back: "Revenir",
				submit: "Soumettre",
				pay: "Payer"
			}
		},
		calendarView: {
			changeService: "changement",
			noAvailability: "Pas de disponibilité",
			noSlotForAppointment: "Il n'y a pas de créneau disponible pour ce rendez-vous. Essayez un autre rendez-vous parmi les options en haut ou sélectionnez un autre jour.",
			noSlotForDay: "Il n'y a pas de disponibilité ce jour-là. Essayez un jour différent du calendrier sur la gauche."
		},
		confirmationView: {
			success: "Succès",
			defaultMessage: "Vous recevrez bientôt un e-mail de confirmation"
		},
		minutes: "minutes",
		cellFieldPlaceholder: "Entrez un numéro de téléphone valide",
		alertMessages: {
			requiredWarning: "Veuillez remplir tous les éléments requis.",
			phoneRequiredMessage: "Le numéro de téléphone est obligatoire, veuillez saisir un numéro de téléphone valide.",
			attachmentRequired: "Veuillez télécharger la pièce jointe requise.",
			answerRequired: "Une réponse est requise, veuillez saisir une valeur correcte.",
			singleAttachment: "Veuillez choisir une seule pièce jointe.",
			attachmentSize: "La taille de la pièce jointe doit être inférieure à 10 mégaoctets.",
			emptyAttachmentFile: "Le fichier de pièce jointe est vide. Veuillez choisir le bon fichier.",
			paymentError: "Un problème est survenu lors de l’obtention du paiement. Veuillez réessayer plus tard ou contacter le support.",
			savingBookingError: "Une erreur s'est produite. Veuillez réessayer.."
		},
		inputFieldErrorMessages: {
			name: "Il est requis de compléter le champ correspondant au nom",
			email: "Le champ Email doit être un email valide",
			cellNumber: "Entrez un numéro de téléphone valide",
			location: "Le champ Emplacement personnalisé est requis"
		}
	},
	// Spanish
	es: {
		appointmentType: {
			dropdownTitle: 'Elija el tipo de cita',
			listTitle: '¿Cuanto necesitas?'
		},
		timeZoneTitle: "¿A qué hora te conviene más?",
		bookingView: {
			hintTexts: {
				name:  "Tu nombre, estará en la invitación del calendario",
				email: "Recibirás una invitación de calendario en esta dirección.",
				cell: "Recibirá una confirmación de reserva en este número de celular.",
				payment: "Proporcione su información de pago para pagar de forma segura",
				location: "Dónde quieres encontrarte a la hora programada",
				customLocation: "Ingrese cualquier ubicación personalizada para la reunión",
				locationPhoneNumber: "Escriba el número de teléfono para la reunión"
			},
			labelTexts: {
				name: "Nombre",
				email: "Correo electrónico",
				cell: "Teléfono móvil",
				payment: "Información del pago",
				location: "Lugar de reunión",
				customLocation: "Ubicación personalizada"
			},
			buttons: {
				back: "Regreso",
				submit: "Enviar",
				pay: "Pagar"
			}
		},
		calendarView: {
			changeService: "cambio",
			noAvailability: "No disponible",
			noSlotForAppointment: "No hay espacio disponible para esta cita. Pruebe una cita diferente de las opciones en la parte superior o seleccione un día diferente.",
			noSlotForDay: "No hay disponibilidad en este día. Pruebe con un día diferente del calendario de la izquierda."
		},
		confirmationView: {
			success: "Éxito",
			defaultMessage: "Recibirás un correo electrónico de confirmación pronto"
		},
		minutes: "minutos",
		cellFieldPlaceholder: "Ingrese un número de teléfono válido",
		alertMessages: {
			requiredWarning: "Complete todos los elementos necesarios.",
			phoneRequiredMessage: "El número de teléfono es obligatorio, ingrese un número de teléfono válido.",
			attachmentRequired: "Cargue el archivo adjunto requerido.",
			answerRequired: "Se requiere respuesta, ingrese un valor correcto.",
			singleAttachment: "Elija un solo archivo adjunto.",
			attachmentSize: "El tamaño del archivo adjunto debe ser inferior a 10 megabytes.",
			emptyAttachmentFile: "El archivo adjunto está vacío. Elija el archivo correcto.",
			paymentError: "Hubo un problema al obtener el pago. Vuelva a intentarlo más tarde o póngase en contacto con el servicio de asistencia.",
			savingBookingError: "Algo salió mal. Por favor, vuelva a intentarlo.."
		},
		inputFieldErrorMessages: {
			name: "El campo Nombre es obligatorio",
			email: "El campo de correo electrónico debe ser un correo electrónico válido",
			cellNumber: "Ingrese un número de teléfono válido",
			location: "El campo de ubicación personalizada es obligatorio"
		}
	},
	// Norwegian
	no: {
		appointmentType: {
			dropdownTitle: 'Velg avtaltype',
			listTitle: 'Hvor lang tid trenger du?'
		},
		timeZoneTitle: 'Hvilken tid fungerer best for deg?',
		bookingView: {
			hintTexts: {
				name: 'Ditt navn vil være på kalenderinvitasjonen',
				email: 'Du vil motta en kalenderinvitasjon på denne adressen',
				cell: 'Du vil motta en bestillingsbekreftelse på dette cellenummeret',
				payment: "Betalinger behandles sikkert av Stripe.com",
				location: "Hvor du ønsker å møte til avtalt tid",
				customLocation: "Angi en egendefinert plassering for møtet",
				locationPhoneNumber: "Skriv inn telefonnummeret for møtet"
			},
			labelTexts: {
				name: "Navn",
				email: "E-post",
				cell: "Mobiltelefon",
				payment: "Betalingsinformasjon",
				location: "Møtested",
				customLocation: "Egendefinert plassering"
			},
			buttons: {
				back: "Gå tilbake",
				submit: "Sende inn",
				pay: "Betale"
			}
		},
		calendarView: {
			changeService: "endring",
			noAvailability: "Ingen tilgjengelighet",
			noSlotForAppointment: "Det er ingen plass tilgjengelig for denne avtalen. Prøv en annen avtale enn alternativene på toppen, eller velg en annen dag.",
			noSlotForDay: "Det er ingen tilgjengelighet denne dagen. Prøv en annen dag enn kalenderen til venstre."
		},
		confirmationView: {
			success: "Suksess",
			defaultMessage: "Du mottar en bekreftelses-e-post snart"
		},
		minutes: "minutter",
		cellFieldPlaceholder: "Skriv inn et gyldig telefonnummer",
		alertMessages: {
			requiredWarning: "Fyll ut alle nødvendige elementene.",
			phoneRequiredMessage: "Telefonnummer er obligatorisk. Vennligst skriv inn et gyldig telefonnummer.",
			attachmentRequired: "Last opp nødvendig vedlegg.",
			answerRequired: "Svar kreves. Vennligst skriv inn en riktig verdi.",
			singleAttachment: "Velg enkelt vedlegg.",
			attachmentSize: "Vedleggsstørrelsen må være mindre enn 10 megabyte.",
			emptyAttachmentFile: "Vedleggsfilen er tom. Velg riktig fil.",
			paymentError: "Det oppsto et problem med å få betalingen. Prøv igjen senere eller kontakt kundestøtten.",
			savingBookingError: "Noe gikk galt, prøv på nytt .."
		},
		inputFieldErrorMessages: {
			name: "Navnefeltet er obligatorisk",
			email: "E-postfeltet må være en gyldig e-postadresse",
			cellNumber: "Skriv inn et gyldig telefonnummer",
			location: "Egendefinert plassering-feltet er obligatorisk"
		}
	},
	// Chinese
	cn: {
		appointmentType: {
			dropdownTitle: '选择约会类型',
			listTitle: '您需要多长时间？'
		},
		timeZoneTitle: '什么时间最适合您？',
		bookingView: {
			hintTexts: {
				name: '您的名字将在日历邀请中',
				email: '您将在此地址上收到日历邀请。',
				cell: '您将收到此单元格号的预订确认信。',
				payment: '提供您的付款信息以安全付款',
				location: "你想在預定時間見面的地方",
				customLocation: "輸入會議的任何自定義位置",
				locationPhoneNumber: "輸入會議電話號碼"
			},
			labelTexts: {
				name: "姓名",
				email: "电子邮件",
				cell: "手机",
				payment: "支付信息",
				location: "會議地點",
				customLocation: "自定義位置"
			},
			buttons: {
				back: "回去",
				submit: "提交",
				pay: "支付"
			}
		},
		calendarView: {
			changeService: "改變",
			noAvailability: "無空房",
			noSlotForAppointment: "沒有可用於此約會的空位。從頂部的選項嘗試其他約會，或者選擇其他日期。",
			noSlotForDay: "這天沒有空位。嘗試從左側的日曆更改日期。"
		},
		confirmationView: {
			success: "成功",
			defaultMessage: "您很快会收到一封确认电子邮件"
		},
		minutes: "分钟",
		cellFieldPlaceholder: "输入有效的电话号码",
		alertMessages: {
			requiredWarning: "请填写所有必填项。",
			phoneRequiredMessage: "电话号码为必填项，请输入有效的电话号码。",
			attachmentRequired: "请上传所需的附件。",
			answerRequired: "必須回答，請輸入正確的值。",
			singleAttachment: "請選擇單個附件。",
			attachmentSize: "附件大小必須小於10 MB。",
			emptyAttachmentFile: "附件文件為空。請選擇正確的文件。",
			paymentError: "付款時出現問題。請稍後重試或與支持人員聯繫。",
			savingBookingError: "出了點問題，請重試。"
		},
		inputFieldErrorMessages: {
			name: "名字的字段是必需的",
			email: "電子郵件字段必須是有效的電子郵件",
			cellNumber: "輸入有效的電話號碼",
			location: "自定義位置字段是必需的"
		}
	},
	// German
	de: {
		appointmentType: {
			dropdownTitle: 'Wählen Sie einen Termintyp',
			listTitle: 'Wie lange brauchst du?'
		},
		timeZoneTitle: 'Welche Zeit funktioniert am besten für Sie?',
		bookingView: {
			hintTexts: {
				name: 'Ihr Name wird auf der Kalendereinladung stehen',
				email: 'Sie erhalten eine Kalendereinladung unter dieser Adresse',
				cell: 'Sie erhalten eine Buchungsbestätigung zu dieser Handynummer',
				payment: 'Zahlungen werden von Stripe.com sicher verarbeitet',
				location: "Wo Sie sich zur vereinbarten Zeit treffen möchten",
				customLocation: "Geben Sie einen benutzerdefinierten Ort für das Meeting ein",
				locationPhoneNumber: "Geben Sie die Telefonnummer für das Treffen ein"
			},
			labelTexts: {
				name: "Name",
				email: "Email",
				cell: "Handy",
				payment: "Zahlung",
				location: "Treffpunkt",
				customLocation: "Benutzerdefinierter Standort"
			},
			buttons: {
				back: "Geh zurück",
				submit: "Einreichen",
				pay: "Zahlungsdetails"
			}
		},
		calendarView: {
			changeService: "Veränderung",
			noAvailability: "Keine Verfügbarkeit",
			noSlotForAppointment: "Für diesen Termin ist kein Platz verfügbar. Probieren Sie einen anderen Termin als oben aus oder wählen Sie einen anderen Tag aus.",
			noSlotForDay: "An diesem Tag gibt es keine Verfügbarkeit. Versuchen Sie es mit einem anderen Tag als im Kalender links."
		},
		confirmationView: {
			success: "Erfolg",
			defaultMessage: "Sie erhalten in Kürze eine Bestätigungs-E-Mail"
		},
		minutes: "Protokoll",
		cellFieldPlaceholder: "Geben Sie eine gültige Telefonnummer ein",
		alertMessages: {
			requiredWarning: "Bitte füllen Sie alle erforderlichen Elemente aus.",
			phoneRequiredMessage: "Telefonnummer ist erforderlich, bitte geben Sie eine gültige Telefonnummer ein.",
			attachmentRequired: "Bitte laden Sie den erforderlichen Anhang hoch.",
			answerRequired: "Antwort ist erforderlich, bitte geben Sie einen korrekten Wert ein.",
			singleAttachment: "Bitte wählen Sie einen einzelnen Anhang.",
			attachmentSize: "Die Anhangsgröße muss weniger als 10 Megabyte betragen.",
			emptyAttachmentFile: "Anhangsdatei ist leer. Bitte wählen Sie die richtige Datei.",
			paymentError: "Es gab ein Problem beim Bezahlen. Bitte versuchen Sie es später erneut oder wenden Sie sich an den Support.",
			savingBookingError: "Etwas ist schief gelaufen. Bitte versuche es erneut.."
		},
		inputFieldErrorMessages: {
			name: "Das Feld Name ist erforderlich",
			email: "Das Feld E-Mail muss eine gültige E-Mail sein",
			cellNumber: "Geben Sie eine gültige Telefonnummer ein",
			location: "Feld 'Benutzerdefinierter Standort' ist erforderlich"
		}
	},
	// Icelandic
	is: {
		appointmentType: {
			dropdownTitle: 'Veldu gerð tíma',
			listTitle: 'Hversu lengi þarftu?'
		},
		timeZoneTitle: 'Hvaða tími hentar þér best?',
		bookingView: {
			hintTexts: {
				name: 'Nafnið þitt verður í dagbókarboðinu',
				email: 'Þú færð dagbókarboð á þessu heimilisfangi',
				cell: 'Þú færð bókunarstaðfestingu á þessu farsímanúmeri',
				payment: "Greiðslur eru afgreiddar á öruggan hátt af Stripe.com",
				location: "Þar sem þú vilt hittast á tilsettum tíma",
				customLocation: "Sláðu inn sérsniðna staðsetningu fyrir fundinn",
				locationPhoneNumber: "Sláðu inn símanúmer fyrir fundinn"
			},
			labelTexts: {
				name: "Nafn",
				email: "Tölvupóstur",
				cell: "Farsími",
				payment: "Greiðsluupplýsingar",
				location: "Fundarstaður",
				customLocation: "Sérsniðin staðsetning"
			},
			buttons: {
				back: "Farðu til baka",
				submit: "Sendu inn",
				pay: "Borgaðu"
			}
		},
		calendarView: {
			changeService: "breyta",
			noAvailability: "Ekkert framboð",
			noSlotForAppointment: "Það er engin rifa í boði fyrir þennan tíma. Prófaðu annan tíma frá valkostunum efst eða veldu annan dag.",
			noSlotForDay: "Það er ekkert framboð þennan dag. Prófaðu annan dag en dagatalið til vinstri."
		},
		confirmationView: {
			success: "Árangur",
			defaultMessage: "Þú færð staðfestingarpóst innan skamms"
		},
		minutes: "mínútur",
		cellFieldPlaceholder: "Sláðu inn gilt símanúmer",
		alertMessages: {
			requiredWarning: "Vinsamlegast fyllið alla nauðsynlega hluti.",
			phoneRequiredMessage: "Símanúmer er krafist, vinsamlegast sláðu inn gilt símanúmer.",
			attachmentRequired: "Vinsamlegast settu inn nauðsynlegt viðhengi.",
			answerRequired: "Svar er krafist, vinsamlegast sláðu inn rétt gildi.",
			singleAttachment: "Vinsamlegast veldu eitt viðhengi.",
			attachmentSize: "Stærð viðhengis verður að vera innan við 10 megabæti.",
			emptyAttachmentFile: "Viðhengisskrá er tóm. Vinsamlegast veldu rétta skrá.",
			paymentError: "Það kom upp vandamál að fá greiðsluna. Reyndu aftur síðar eða hafðu samband við þjónustudeildina.",
			savingBookingError: "Eitthvað fór úrskeiðis, reyndu aftur .."
		},
		inputFieldErrorMessages: {
			name: "Nafnreiturinn er nauðsynlegur",
			email: "Reiturinn Tölvupóstur verður að vera gilt netfang",
			cellNumber: "Sláðu inn gilt símanúmer",
			location: "Sérsniðin staðsetningarreitur er nauðsynlegur"
		}
	},
	// Netherlands (Dutch)
	nl: {
		appointmentType: {
			dropdownTitle: "Kies afspraaktype",
			listTitle: "Hoe lang heb je nodig?"
		},
		timeZoneTitle: "Welke tijd werkt het beste voor jou?",
		bookingView: {
			hintTexts: {
				name: "Je naam staat op de agenda-uitnodiging",
				email: "Op dit adres ontvang je een agenda-uitnodiging",
				cell: "Op dit mobiele nummer ontvang je een boekingsbevestiging",
				payment: "Betalingen worden veilig verwerkt door Stripe.com",
				location: "Waar je wilt afspreken op de geplande tijd",
				customLocation: "Voer een aangepaste locatie voor de vergadering in",
				locationPhoneNumber: "Typ het telefoonnummer voor de vergadering"
			},
			labelTexts: {
				name: "Naam",
				email: "E-mail",
				cell: "Mobiele telefoon",
				payment: "Betalingsdetails",
				location: "Vergaderlocatie",
				customLocation: "Aangepaste locatie"
			},
			buttons: {
				back: "Ga terug",
				submit: "Indienen",
				pay: "Betalen"
			}
		},
		calendarView: {
			changeService: "verandering",
			noAvailability: "Geen beschikbaarheid",
			noSlotForAppointment: "Er is geen plaats voor deze afspraak. Probeer een andere afspraak uit de opties bovenaan of selecteer een andere dag.",
			noSlotForDay: "Op deze dag is er geen beschikbaarheid. Probeer een andere dag dan de kalender aan de linkerkant."
		},
		confirmationView: {
			success: "Succes",
			defaultMessage: "U ontvangt binnenkort een bevestigingsmail"
		},
		minutes: "minuten",
		cellFieldPlaceholder: "Voer een geldig telefoonnummer in",
		alertMessages: {
			requiredWarning: "Vul alstublieft alle vereiste items in.",
			phoneRequiredMessage: "Telefoonnummer is vereist, voer een geldig telefoonnummer in.",
			attachmentRequired: "Upload de vereiste bijlage.",
			answerRequired: "Antwoord is vereist, typ een juiste waarde in.",
			singleAttachment: "Kies een enkele bijlage.",
			attachmentSize: "De bijlagegrootte moet kleiner zijn dan 10 megabytes.",
			emptyAttachmentFile: "Bijlagebestand is leeg. Kies het juiste bestand.",
			paymentError: "Það kom upp vandamál að fá greiðsluna. Reyndu aftur síðar eða hafðu samband við þjónustudeildina.",
			savingBookingError: "Er is iets mis gegaan, probeer het alstublieft nogmaals.."
		},
		inputFieldErrorMessages: {
			name: "Het veld Naam is verplicht",
			email: "Het e-mailveld moet een geldig e-mailadres zijn",
			cellNumber: "Voer een geldig telefoonnummer in",
			location: "Aangepast veld voor locatie is verplicht"
		}
	},
	// Swedish
	se: {
		appointmentType: {
			dropdownTitle: 'Välj typ av möte',
			listTitle: 'Hur länge behöver du?'
		},
		timeZoneTitle: 'Vilken tid fungerar bäst för dig?',
		bookingView: {
			hintTexts: {
				name: 'Ditt namn kommer att finnas i kalenderinbjudan',
				email: 'Du kommer att få en kalenderinbjudan på den här adressen',
				cell: 'Du kommer att få en bokningsbekräftelse på detta mobilnummer',
				payment: "Betalningar behandlas säkert av Stripe.com",
				location: "Där du vill träffas på utsatt tid",
				customLocation: "Ange valfri anpassad plats för mötet",
				locationPhoneNumber: "Skriv in telefonnumret för mötet"
			},
			labelTexts: {
				name: "Namn",
				email: "E-post",
				cell: "Mobiltelefon",
				payment: "betalningsinformation",
				location: "Mötesplats",
				customLocation: "Anpassad plats"
			},
			buttons: {
				back: "Gå tillbaka",
				submit: "Skicka in",
				pay: "Betala"
			}
		},
		calendarView: {
			changeService: "förändra",
			noAvailability: "Ingen tillgänglighet",
			noSlotForAppointment: "Ingen plats tillgänglig för det här mötet. Testa ett annat möte än alternativen högst upp eller välj en annan dag.",
			noSlotForDay: "Ingen tillgänglighet den här dagen. Prova en annan dag än kalendern till vänster."
		},
		confirmationView: {
			success: "Framgång",
			defaultMessage: "Du kommer snart att få ett bekräftelsemeddelande"
		},
		minutes: "minuter",
		cellFieldPlaceholder: "Ange ett giltigt telefonnummer",
		alertMessages: {
			requiredWarning: "Fyll i alla nödvändiga artiklar.",
			phoneRequiredMessage: "Telefonnummer krävs, skriv ett giltigt telefonnummer.",
			attachmentRequired: "Ladda upp den bifogade bilagan.",
			answerRequired: "Svar krävs, skriv ett korrekt värde.",
			singleAttachment: "Välj enstaka bilaga.",
			attachmentSize: "Bilagans storlek måste vara mindre än 10 megabyte.",
			emptyAttachmentFile: "Bilagefilen är tom. Välj rätt fil.",
			paymentError: "Det uppstod ett problem med att få betalningen. Försök igen senare eller kontakta supporten.",
			savingBookingError: "Något gick fel, försök igen .."
		},
		inputFieldErrorMessages: {
			name: "Namnfältet krävs",
			email: "E-postfältet måste vara ett giltigt e-postmeddelande",
			cellNumber: "Ange ett giltigt telefonnummer",
			location: "Fält för anpassad plats är obligatoriskt"
		}
	},
	// Japanese
	ja: {
		appointmentType: {
			dropdownTitle: '予約の種類を選択してください',
			listTitle: 'どれくらい必要ですか？'
		},
		timeZoneTitle: 'あなたにとって最適な時間は何時ですか？',
		bookingView: {
			hintTexts: {
				name: 'あなたの名前は、カレンダーの招待状に表示されます',
				email: 'このアドレスでカレンダーの招待状を受け取ります',
				cell: 'このセル番号で予約確認を受け取ります',
				payment: "支払いはStripe.comによって安全に処理されます",
				location: "予定時刻に会いたい場所",
				customLocation: "会議のカスタムの場所を入力します",
				locationPhoneNumber: "会議用の電話番号を入力します"
			},
			labelTexts: {
				name: "名前",
				email: "Eメール",
				cell: "携帯電話",
				payment: "支払詳細",
				location: "待ち合わせ場所",
				customLocation: "カスタムロケーション"
			},
			buttons: {
				back: "戻る",
				submit: "送信",
				pay: "支払い"
			}
		},
		calendarView: {
			changeService: "変化する",
			noAvailability: "可用性なし",
			noSlotForAppointment: "この予定に利用できるスロットはありません。上部のオプションとは別の予定を試すか、別の日を選択してください。",
			noSlotForDay: "この日は空室がありません。左のカレンダーとは別の日をお試しください。"
		},
		confirmationView: {
			success: "成功",
			defaultMessage: "すぐに確認メールが届きます"
		},
		minutes: "分",
		cellFieldPlaceholder: "有効な電話番号を入力してください",
		alertMessages: {
			requiredWarning: "必要事項をすべて記入してください。",
			phoneRequiredMessage: "電話番号が必要です。有効な電話番号を入力してください。",
			attachmentRequired: "必要な添付ファイルをアップロードしてください。",
			answerRequired: "回答が必要です。正しい値を入力してください。",
			singleAttachment: "シングルアタッチメントをお選びください。",
			attachmentSize: "添付ファイルのサイズは10メガバイト未満である必要があります。",
			emptyAttachmentFile: "添付ファイルが空です。正しいファイルを選択してください。",
			paymentError: "支払いの受け取りに問題がありました。後で再試行するか、サポートに連絡してください。",
			savingBookingError: "何かが間違っていました。もう一度やり直してください。"
		},
		inputFieldErrorMessages: {
			name: "名前フィールドは必須です",
			email: "[メール]フィールドは有効なメールである必要があります",
			cellNumber: "有効な電話番号を入力してください",
			location: "カスタムロケーションフィールドは必須です"
		}
	},
	// Czech
	cs: {
		appointmentType: {
			dropdownTitle: "Vyberte typ schůzky",
			listTitle: "Hur länge behöver du?"
		},
		timeZoneTitle: "Který čas vám nejlépe vyhovuje?",
		bookingView: {
			hintTexts: {
				name: "Vaše jméno bude v pozvánce do kalendáře",
				email: "Na tuto adresu obdržíte pozvánku do kalendáře",
				cell: "Na toto číslo buňky obdržíte potvrzení rezervace",
				payment: "Platby jsou bezpečně zpracovávány Stripe.com",
				location: "Kde se chcete sejít v plánovaný čas",
				customLocation: "Zadejte libovolné vlastní místo schůzky",
				locationPhoneNumber: "Zadejte telefonní číslo pro schůzku"
			},
			labelTexts: {
				name: "Název",
				email: "E-mail",
				cell: "Mobilní telefon",
				payment: "Platební údaje",
				location: "Místo setkání",
				customLocation: "Vlastní umístění"
			},
			buttons: {
				back: "Vrať se",
				submit: "Předložit",
				pay: "Platit"
			}
		},
		calendarView: {
			changeService: "změna",
			noAvailability: "Nedostupný",
			noSlotForAppointment: "Pro tuto schůzku není k dispozici žádný slot. Zkuste jinou schůzku z možností nahoře nebo vyberte jiný den.",
			noSlotForDay: "V tento den není k dispozici. Zkuste jiný den z kalendáře vlevo."
		},
		confirmationView: {
			success: "Úspěch",
			defaultMessage: "Brzy obdržíte potvrzovací e -mail"
		},
		minutes: "minut",
		cellFieldPlaceholder: "Zadejte platné telefonní číslo",
		alertMessages: {
			requiredWarning: "Vyplňte prosím všechny požadované položky.",
			phoneRequiredMessage: "Telefonní číslo je povinné, zadejte prosím platné telefonní číslo.",
			attachmentRequired: "Nahrajte prosím požadovanou přílohu.",
			answerRequired: "Odpověď je vyžadována, zadejte prosím správnou hodnotu.",
			singleAttachment: "Vyberte jednu přílohu.",
			attachmentSize: "Velikost přílohy musí být menší než 10 megabajtů.",
			emptyAttachmentFile: "Soubor přílohy je prázdný. Vyberte prosím správný soubor.",
			paymentError: "Při přijímání platby došlo k problému. Zkuste to prosím znovu později nebo kontaktujte podporu.",
			savingBookingError: "Něco se pokazilo. Prosím zkuste to znovu."
		},
		inputFieldErrorMessages: {
			name: "Pole Jméno je povinné",
			email: "Pole E -mail musí být platný e -mail",
			cellNumber: "Zadejte platné telefonní číslo",
			location: "Pole Vlastní umístění je povinné"
		}
	},
	// Arabic
	ar: {
		appointmentType: {
			dropdownTitle: 'اختر نوع الموعد',
			listTitle: 'ما هي المدة التي تحتاجها؟'
		},
		timeZoneTitle: 'ما هو الوقت المناسب لك؟',
		bookingView: {
			hintTexts: {
				name: 'سيكون اسمك على دعوة التقويم',
				email: 'سوف تتلقى دعوة التقويم على هذا العنوان',
				cell: 'سوف تتلقى تأكيد الحجز على رقم الهاتف الخلوي هذا',
				payment: "تتم معالجة المدفوعات بأمان بواسطة Stripe.com",
				location: "اختر المكان الذي تود الاجتماع فيه في الوقت المحدد",
				customLocation: "أدخل أي موقع مخصص للاجتماع",
				locationPhoneNumber: "اكتب رقم هاتف الاجتماع"
			},
			labelTexts: {
				name: "الإسم",
				email: "البريد الالكتروني",
				cell: "الهاتف الخلوي",
				payment: "بيانات الدفع",
				location: "مكان الاجتماع",
				customLocation: "موقع مخصص"
			},
			buttons: {
				back: "رجوع",
				submit: "إرسال",
				pay: "دفع"
			}
		},
		calendarView: {
			changeService: "تغيير",
			noAvailability: "غير متوفر",
			noSlotForAppointment: "لا يوجد مكان متاح لهذا الموعد. جرب موعدًا مختلفًا من الخيارات الموجودة في الأعلى أو حدد يومًا مختلفًا.",
			noSlotForDay: "لا يوجد فرصه في هذا اليوم. جرب يومًا مختلفًا عن طريق التقويم الموجود على اليسار."
		},
		confirmationView: {
			success: "تم الحجز",
			defaultMessage: "ستتلقى رسالة تأكيد بالبريد الإلكتروني قريبًا"
		},
		minutes: "دقيقة",
		cellFieldPlaceholder: "يرجى كتابة رقم هاتف صحيح",
		alertMessages: {
			requiredWarning: "الرجاء ملء جميع العناصر المطلوبة.",
			phoneRequiredMessage: "رقم الهاتف مطلوب ، يرجى كتابة رقم هاتف صحيح.",
			attachmentRequired: "الرجاء تحميل المرفق المطلوب.",
			answerRequired: "الإجابة مطلوبة ، يرجى كتابة القيمة الصحيحة.",
			singleAttachment: "الرجاء اختيار مرفق واحد.",
			attachmentSize: "يجب أن يكون حجم المرفق أقل من 10 ميغا بايت.",
			emptyAttachmentFile: "الملف المرفق فارغ. الرجاء اختيار الملف الصحيح.",
			paymentError: "كانت هناك مشكلة في الحصول على الدفع. يرجى المحاولة مرة أخرى لاحقًا أو الاتصال بالدعم.",
			savingBookingError: "حدث خطأ ما. أعد المحاولة من فضلك.."
		},
		inputFieldErrorMessages: {
			name: "حقل الاسم مطلوب",
			email: "يجب أن يكون حقل البريد الإلكتروني بريدًا إلكترونيًا صالحًا",
			cellNumber: "أدخل رقم هاتف صالح",
			location: "حقل الموقع المخصص مطلوب"
		}
	},
	// Polish
	pl: {
		"appointmentType": {
			"dropdownTitle": "Wybierz typ spotkania",
			"listTitle": "Jak długo potrzebujesz?"
		},
		"timeZoneTitle": "Która godzina jest dla Ciebie najlepsza?",
		"bookingView": {
			"hintTexts": {
				"name": "Twoje imię i nazwisko będzie w kalendarzu zaproszenie",
				"email": "Na ten adres otrzymasz zaproszenie z kalendarza",
				"cell": "Otrzymasz potwierdzenie rezerwacji na ten numer komórki",
				"payment": "Płatności są bezpiecznie przetwarzane przez Stripe.com",
				"location": "Wybierz, gdzie chciałbyś się spotkać w zaplanowanym czasie",
				"customLocation": "Wpisz dowolną niestandardową lokalizację spotkania",
				"locationPhoneNumber": "Wpisz numer telefonu do spotkania"
			},
			"labelTexts": {
				"name": "Nazwa",
				"email": "E-mail",
				"cell": "Telefon komórkowy",
				"payment": "Szczegóły płatności",
				"location": "Miejsce spotkania",
				"customLocation": "Lokalizacja niestandardowa"
			},
			"buttons": {
				"back": "Wróć",
				"submit": "Składać",
				"pay": "Płacić"
			}
		},
		"calendarView": {
			"changeService": "zmiana",
			"noAvailability": "Nie dostępny",
			"noSlotForAppointment": "Brak dostępnego przedziału dla tego spotkania. Wypróbuj inne spotkanie z opcji na górze lub wybierz inny dzień.",
			"noSlotForDay": "Brak dostępności w tym dniu. Wypróbuj inny dzień z kalendarza po lewej stronie."
		},
		"confirmationView": {
			"success": "Powodzenie",
			"defaultMessage": "Wkrótce otrzymasz e-mail z potwierdzeniem"
		},
		"minutes": "minuty",
		"cellFieldPlaceholder": "Wpisz poprawny numer telefonu",
		"alertMessages": {
			"requiredWarning": "Proszę wypełnić wszystkie wymagane pozycje.",
			"phoneRequiredMessage": "Numer telefonu jest wymagany, proszę wpisać poprawny numer telefonu.",
			"attachmentRequired": "Prześlij wymagany załącznik.",
			"answerRequired": "Odpowiedź jest wymagana, proszę wpisać poprawną wartość.",
			"singleAttachment": "Proszę wybrać pojedynczy załącznik.",
			"attachmentSize": "Rozmiar załącznika musi być mniejszy niż 10 megabajtów.",
			"emptyAttachmentFile": "Plik załącznika jest pusty. Proszę wybrać poprawny plik.",
			"paymentError": "Podczas pobierania płatności wystąpił problem. Spróbuj ponownie później lub skontaktuj się z pomocą techniczną.",
			"savingBookingError": "Coś poszło nie tak. Proszę spróbuj ponownie.."
		},
		"inputFieldErrorMessages": {
			"name": "Pole Imię jest wymagane",
			"email": "Pole E-mail musi być prawidłowym adresem e-mail",
			"cellNumber": "Wpisz poprawny numer telefonu",
			"location": "Pole Lokalizacja niestandardowa jest wymagane"
		}
	},
	// Russian
	ru: {
		"appointmentType": {
			"dropdownTitle": "Выберите тип встречи",
			"listTitle": "Как долго вам нужно?"
		},
		"timeZoneTitle": "Какое время лучше всего подходит для вас?",
		"bookingView": {
			"hintTexts": {
				"name": "Ваше имя будет в приглашении календаря",
				"email": "Вы получите приглашение календаря на этот адрес",
				"cell": "Вы получите подтверждение бронирования на этот номер мобильного телефона",
				"payment": "Платежи безопасно обрабатываются Stripe.com",
				"location": "Выберите, где вы хотели бы встретиться в назначенное время",
				"customLocation": "Введите любое пользовательское место для встречи",
				"locationPhoneNumber": "Введите номер телефона для встречи"
			},
			"labelTexts": {
				"name": "Имя",
				"email": "Электронное письмо",
				"cell": "Мобильный телефон",
				"payment": "Детали оплаты",
				"location": "Место встречи",
				"customLocation": "Пользовательское местоположение"
			},
			"buttons": {
				"back": "Возвращаться",
				"submit": "Представлять на рассмотрение",
				"pay": "Платить"
			}
		},
		"calendarView": {
			"changeService": "изменять",
			"noAvailability": "Недоступно",
			"noSlotForAppointment": "Нет свободного места для этой встречи. Попробуйте другую встречу из вариантов вверху или выберите другой день.",
			"noSlotForDay": "В этот день мест нет. Попробуйте выбрать другой день из календаря слева."
		},
		"confirmationView": {
			"success": "Успех",
			"defaultMessage": "Вскоре вы получите электронное письмо с подтверждением"
		},
		"minutes": "минуты",
		"cellFieldPlaceholder": "Введите действительный номер телефона",
		"alertMessages": {
			"requiredWarning": "Пожалуйста, заполните все необходимые пункты.",
			"phoneRequiredMessage": "Требуется номер телефона, пожалуйста, введите действительный номер телефона.",
			"attachmentRequired": "Пожалуйста, загрузите необходимое вложение.",
			"answerRequired": "Требуется ответ, пожалуйста, введите правильное значение.",
			"singleAttachment": "Пожалуйста, выберите одно вложение.",
			"attachmentSize": "Размер вложения не должен превышать 10 мегабайт.",
			"emptyAttachmentFile": "Вложенный файл пустой. Пожалуйста, выберите правильный файл.",
			"paymentError": "Возникла проблема с получением платежа. Повторите попытку позже или обратитесь в службу поддержки.",
			"savingBookingError": "Что-то пошло не так. Пожалуйста, попытайтесь еще раз.."
		},
		"inputFieldErrorMessages": {
			"name": "Необходимо ввести имя в поле",
			"email": "Поле Электронная почта должно быть действительным адресом электронной почты.",
			"cellNumber": "Введите действительный номер телефона",
			"location": "Обязательное поле 'Пользовательское местоположение'"
		}
	},

	// Italian
	it: {
		"appointmentType": {
			"dropdownTitle": "Scegli il tipo di appuntamento",
			"listTitle": "Quanto tempo hai bisogno?"
		},
		"timeZoneTitle": "Qual è il momento migliore per te?",
		"bookingView": {
			"hintTexts": {
				"name": "Il tuo nome sarà sull'invito del calendario",
				"email": "Riceverai un invito del calendario a questo indirizzo",
				"cell": "Riceverai una conferma di prenotazione su questo numero di cellulare",
				"payment": "I pagamenti vengono elaborati in modo sicuro da Stripe.com",
				"location": "Scegli dove vorresti incontrarti all'ora programmata",
				"customLocation": "Inserisci un luogo personalizzato per la riunione",
				"locationPhoneNumber": "Digita il numero di telefono per la riunione"
			},
			"labelTexts": {
				"name": "Nome",
				"email": "E-mail",
				"cell": "Cellulare",
				"payment": "Dettagli di pagamento",
				"location": "Luogo dell'incontro",
				"customLocation": "Posizione personalizzata"
			},
			"buttons": {
				"back": "Torna indietro",
				"submit": "Invia",
				"pay": "Paga"
			}
		},
		"calendarView": {
			"changeService": "modificare",
			"noAvailability": "Nessuna disponibilità",
			"noSlotForAppointment": "Nessuno spazio disponibile per questo appuntamento. Prova un appuntamento diverso dalle opzioni in alto o seleziona un giorno diverso.",
			"noSlotForDay": "Nessuna disponibilità in questo giorno. Prova un giorno diverso dal calendario a sinistra."
		},
		"confirmationView": {
			"success": "Successo",
			"defaultMessage": "Riceverai presto un'e-mail di conferma"
		},
		"minutes": "minuti",
		"cellFieldPlaceholder": "Inserisci un numero di telefono valido",
		"alertMessages": {
			"requiredWarning": "Si prega di compilare tutti gli elementi richiesti.",
			"phoneRequiredMessage": "Il numero di telefono è richiesto, si prega di digitare un numero di telefono valido.",
			"attachmentRequired": "Si prega di caricare l'allegato richiesto.",
			"answerRequired": "La risposta è richiesta, si prega di digitare un valore corretto.",
			"singleAttachment": "Si prega di scegliere allegato singolo.",
			"attachmentSize": "La dimensione dell'allegato deve essere inferiore a 10 megabyte.",
			"emptyAttachmentFile": "Il file allegato è vuoto. Si prega di scegliere il file corretto.",
			"paymentError": "Errore durante l'elaborazione del pagamento. Riprova o contatta l'assistenza.",
			"savingBookingError": "Qualcosa è andato storto, prova ancora.."
		},
		"inputFieldErrorMessages": {
			"name": "È richiesto il campo nome",
			"email": "Il campo E-mail deve essere un'e-mail valida",
			"cellNumber": "Inserisci un numero di telefono valido",
			"location": "Il campo Posizione personalizzata è obbligatorio"
		}
	},
	// Finnish
	fi: {
	"appointmentType": {
			"dropdownTitle": "Valitse tapaamistyyppi",
			"listTitle": "Kuinka kauan tarvitset?"
		},
		"timeZoneTitle": "Mikä aika toimii sinulle parhaiten?",
		"bookingView": {
			"hintTexts": {
				"name": "Nimesi tulee olemaan kalenterin kutsussa",
				"email": "Saat kalenterikutsun tähän osoitteeseen",
				"cell": "Saat varausvahvistuksen tähän solunumeroon",
				"payment": "Stripe.com käsittelee maksut turvallisesti",
				"location": "Valitse, missä haluat tavata sovittuna aikana",
				"customLocation": "Kirjoita kokouksen paikka",
				"locationPhoneNumber": "Kirjoita tapaamisen puhelinnumero"
			},
			"labelTexts": {
				"name": "Nimi",
				"email": "Sähköposti",
				"cell": "Kännykkä",
				"payment": "Maksutiedot",
				"location": "Kokouspaikka",
				"customLocation": "Sijainti"
			},
			"buttons": {
				"back": "Mene takaisin",
				"submit": "Lähetä",
				"pay": "Maksaa"
			}
		},
		"calendarView": {
			"changeService": "muuttaa",
			"noAvailability": "Ei saatavuutta",
			"noSlotForAppointment": "Tälle tapaamiselle ei ole vapaata paikkaa. Kokeile toista tapaamista ylhäällä olevista vaihtoehdoista tai valitse toinen päivä.",
			"noSlotForDay": "Ei saatavuutta tänä päivänä. Kokeile toista päivää vasemmalla olevasta kalenterista."
		},
		"confirmationView": {
			"success": "Menestys",
			"defaultMessage": "Saat pian vahvistussähköpostin"
		},
		"minutes": "pöytäkirja",
		"cellFieldPlaceholder": "Anna kelvollinen puhelinnumero",
		"alertMessages": {
			"requiredWarning": "Täytä kaikki vaaditut kohteet.",
			"phoneRequiredMessage": "Puhelinnumero vaaditaan, kirjoita kelvollinen puhelinnumero.",
			"attachmentRequired": "Lataa vaadittu liite.",
			"answerRequired": "Vastaus vaaditaan, kirjoita oikea arvo.",
			"singleAttachment": "Valitse yksi liite.",
			"attachmentSize": "Liitteen koon on oltava alle 10 megatavua.",
			"emptyAttachmentFile": "Liitetiedosto on tyhjä. Valitse oikea tiedosto.",
			"paymentError": "Virhe maksun käsittelyssä. Yritä uudelleen tai ota yhteyttä tukeen.",
			"savingBookingError": "Jokin meni vikaan. ole hyvä ja yritä uudelleen.."
		},
		"inputFieldErrorMessages": {
			"name": "Nimi-kenttä on pakollinen",
			"email": "Sähköposti-kentän on oltava kelvollinen sähköpostiosoite",
			"cellNumber": "Anna kelvollinen puhelinnumero",
			"location": "Mukautettu sijainti -kenttä on pakollinen"
		}
	},

	// Slovak
	sk: {
		"appointmentType": {
			"dropdownTitle": "Vyberte typ stretnutia",
			"listTitle": "Ako dlho potrebujete?"
		},
		"timeZoneTitle": "Aký čas vám najviac vyhovuje?",
		"bookingView": {
			"hintTexts": {
				"name": "Vaše meno bude uvedené v pozvánke v kalendári",
				"email": "Na túto adresu dostanete pozvánku do kalendára",
				"cell": "Na toto mobilné číslo dostanete potvrdenie rezervácie",
				"payment": "Platby sú bezpečne spracovávané Stripe.com",
				"location": "Vyberte si, kde by ste sa chceli stretnúť v plánovanom čase",
				"customLocation": "Zadajte miesto stretnutia",
				"locationPhoneNumber": "Zadajte telefónne číslo na stretnutie"
			},
			"labelTexts": {
				"name": "Názov",
				"email": "Email",
				"cell": "Mobilný telefón",
				"payment": "Platobné údaje",
				"location": "Miesto stretnutia",
				"customLocation": "Miesto"
			},
			"buttons": {
				"back": "Vráť sa",
				"submit": "Predložiť",
				"pay": "Zaplatiť"
			}
		},
		"calendarView": {
			"changeService": "zmeniť",
			"noAvailability": "Žiadna dostupnosť",
			"noSlotForAppointment": "Pre túto schôdzku nie je k dispozícii žiadny slot. Skúste inú schôdzku z možností v hornej časti alebo vyberte iný deň.",
			"noSlotForDay": "V tento deň nie je k dispozícii. Skúste iný deň ako v kalendári vľavo."
		},
		"confirmationView": {
			"success": "Úspech",
			"defaultMessage": "Čoskoro dostanete potvrdzujúci e-mail"
		},
		"minutes": "minút",
		"cellFieldPlaceholder": "Zadajte platné telefónne číslo",
		"alertMessages": {
			"requiredWarning": "Vyplňte prosím všetky požadované položky.",
			"phoneRequiredMessage": "Vyžaduje sa telefónne číslo, zadajte platné telefónne číslo.",
			"attachmentRequired": "Nahrajte požadovanú prílohu.",
			"answerRequired": "Vyžaduje sa odpoveď, zadajte správnu hodnotu.",
			"singleAttachment": "Vyberte jednu prílohu.",
			"attachmentSize": "Veľkosť prílohy musí byť menšia ako 10 megabajtov.",
			"emptyAttachmentFile": "Súbor s prílohou je prázdny. Vyberte správny súbor.",
			"paymentError": "Chyba pri spracovaní platby. Skúste to znova alebo kontaktujte podporu.",
			"savingBookingError": "Niečo sa pokazilo, skúste to znova.."
		},
		"inputFieldErrorMessages": {
			"name": "Pole Názov je povinné",
			"email": "Pole Email musí byť platný email",
			"cellNumber": "Zadajte platné telefónne číslo",
			"location": "Pole Custom Location je povinné"
		}
	},

	// Greek
	el: {
		"appointmentType": {
			"dropdownTitle": "Επιλέξτε τύπο συνάντησης",
			"listTitle": "Πόσο καιρό χρειάζεστε;"
		},
		"timeZoneTitle": "Ποια ώρα λειτουργεί καλύτερα για εσάς;",
		"bookingView": {
			"hintTexts": {
				"name": "Το όνομά σας θα είναι στην πρόσκληση του ημερολογίου",
				"email": "Θα λάβετε μια πρόσκληση ημερολογίου σε αυτήν τη διεύθυνση",
				"cell": "Θα λάβετε μια επιβεβαίωση κράτησης σε αυτόν τον αριθμό κινητού τηλεφώνου",
				"payment": "Οι πληρωμές επεξεργάζονται με ασφάλεια από το Stripe.com",
				"location": "Επιλέξτε πού θα θέλατε να συναντηθείτε την προγραμματισμένη ώρα",
				"customLocation": "Πληκτρολογήστε την τοποθεσία για τη συνάντηση",
				"locationPhoneNumber": "Πληκτρολογήστε τον αριθμό τηλεφώνου για τη συνάντηση"
			},
			"labelTexts": {
				"name": "Ονομα",
				"email": "ηλεκτρονικη διευθυνση",
				"cell": "Κινητό τηλέφωνο",
				"payment": "Οι λεπτομέρειες πληρωμής",
				"location": "Τοποθεσία συνάντησης",
				"customLocation": "Τοποθεσία"
			},
			"buttons": {
				"back": "Πήγαινε πίσω",
				"submit": "υποβάλλουν",
				"pay": "Πληρωμή"
			}
		},
		"calendarView": {
			"changeService": "αλλαγή",
			"noAvailability": "Δεν υπάρχει διαθεσιμότητα",
			"noSlotForAppointment": "Δεν υπάρχει διαθέσιμος χρόνος για αυτό το ραντεβού. Δοκιμάστε ένα διαφορετικό ραντεβού από τις επιλογές στο επάνω μέρος ή επιλέξτε μια διαφορετική ημέρα.",
			"noSlotForDay": "Δεν υπάρχει διαθεσιμότητα αυτήν την ημέρα. Δοκιμάστε μια διαφορετική ημέρα από το ημερολόγιο στα αριστερά."
		},
		"confirmationView": {
			"success": "Επιτυχία",
			"defaultMessage": "Θα λάβετε σύντομα ένα email επιβεβαίωσης"
		},
		"minutes": "λεπτά",
		"cellFieldPlaceholder": "Εισαγάγετε έναν έγκυρο αριθμό τηλεφώνου",
		"alertMessages": {
			"requiredWarning": "Συμπληρώστε όλα τα απαραίτητα στοιχεία.",
			"phoneRequiredMessage": "Απαιτείται αριθμός τηλεφώνου, πληκτρολογήστε έναν έγκυρο αριθμό τηλεφώνου.",
			"attachmentRequired": "Ανεβάστε το απαιτούμενο συνημμένο.",
			"answerRequired": "Απαιτείται απάντηση, πληκτρολογήστε τη σωστή τιμή.",
			"singleAttachment": "Επιλέξτε μεμονωμένο συνημμένο.",
			"attachmentSize": "Το μέγεθος του συνημμένου πρέπει να είναι μικρότερο από 10 megabyte.",
			"emptyAttachmentFile": "Το αρχείο συνημμένου είναι κενό. Επιλέξτε το σωστό αρχείο.",
			"paymentError": "Σφάλμα κατά την επεξεργασία της πληρωμής. Δοκιμάστε ξανά ή επικοινωνήστε με την υποστήριξη.",
			"savingBookingError": "Κάτι δεν πήγε καλά. Παρακαλώ ξαναπροσπαθήστε.."
		},
		"inputFieldErrorMessages": {
			"name": "Το πεδίο όνομα είναι απαραίτητο",
			"email": "Το πεδίο Email πρέπει να είναι έγκυρο email",
			"cellNumber": "Εισαγάγετε έναν έγκυρο αριθμό τηλεφώνου",
			"location": "Απαιτείται το πεδίο προσαρμοσμένης τοποθεσίας"
		}
	},

	// Danish
	da: {
		"appointmentType": {
			"dropdownTitle": "Vælg aftaletype",
			"listTitle": "Hvor lang tid har du brug for?"
		},
		"timeZoneTitle": "Hvilket tidspunkt fungerer bedst for dig?",
		"bookingView": {
			"hintTexts": {
				"name": "Dit navn vil være på kalenderinvitationen",
				"email": "Du vil modtage en kalenderinvitation på denne adresse",
				"cell": "Du vil modtage en reservationsbekræftelse på dette cellenummer",
				"payment": "Betalinger behandles sikkert af Stripe.com",
				"location": "Vælg, hvor du gerne vil mødes på det aftalte tidspunkt",
				"customLocation": "Indtast stedet for mødet",
				"locationPhoneNumber": "Indtast telefonnummeret til mødet"
			},
			"labelTexts": {
				"name": "Navn",
				"email": "E-mail",
				"cell": "Mobiltelefon",
				"payment": "Betalingsoplysninger",
				"location": "Mødested",
				"customLocation": "Beliggenhed"
			},
			"buttons": {
				"back": "Gå tilbage",
				"submit": "Indsend",
				"pay": "Betale"
			}
		},
		"calendarView": {
			"changeService": "lave om",
			"noAvailability": "Ingen tilgængelighed",
			"noSlotForAppointment": "Der er ingen ledig plads til denne aftale. Prøv en anden aftale fra valgmulighederne øverst, eller vælg en anden dag.",
			"noSlotForDay": "Ingen tilgængelighed på denne dag. Prøv en anden dag fra kalenderen til venstre."
		},
		"confirmationView": {
			"success": "Succes",
			"defaultMessage": "Du modtager snart en bekræftelsesmail"
		},
		"minutes": "minutter",
		"cellFieldPlaceholder": "Indtast et gyldigt telefonnummer",
		"alertMessages": {
			"requiredWarning": "Udfyld venligst alle nødvendige elementer.",
			"phoneRequiredMessage": "Telefonnummer er påkrævet, indtast venligst et gyldigt telefonnummer.",
			"attachmentRequired": "Upload venligst den nødvendige vedhæftede fil.",
			"answerRequired": "Svar er påkrævet, indtast venligst en korrekt værdi.",
			"singleAttachment": "Vælg venligst enkelt vedhæftet fil.",
			"attachmentSize": "Størrelsen på vedhæftet fil skal være mindre end 10 megabyte.",
			"emptyAttachmentFile": "Den vedhæftede fil er tom. Vælg den korrekte fil.",
			"paymentError": "Fejl ved behandling af betaling. Prøv igen, eller kontakt support.",
			"savingBookingError": "Noget gik galt. Prøv venligst igen.."
		},
		"inputFieldErrorMessages": {
			"name": "Feltet Navn er påkrævet",
			"email": "E-mail-feltet skal være en gyldig e-mail",
			"cellNumber": "Indtast et gyldigt telefonnummer",
			"location": "Feltet Tilpasset placering er påkrævet"
		}
	},
	// Romanian
	ro: {
		"appointmentType": {
			"dropdownTitle": "Alegeți tipul de întâlnire",
			"listTitle": "De cât timp ai nevoie?"
		},
		"timeZoneTitle": "La ce oră funcționează cel mai bine pentru tine?",
		"bookingView": {
			"hintTexts": {
				"name": "Numele tău va fi pe invitația din calendar",
				"email": "Veți primi o invitație în calendar la această adresă",
				"cell": "Veți primi o confirmare de rezervare la acest număr",
				"payment": "Plățile sunt procesate în siguranță de Stripe.com",
				"location": "Alegeți unde doriți să vă întâlniți la ora programată",
				"customLocation": "Introduceți locația întâlnirii",
				"locationPhoneNumber": "Introduceți numărul de mobil pentru întâlnire"
			},
			"labelTexts": {
				"name": "Nume",
				"email": "E-mail",
				"cell": "Număr de telefon mobil",
				"payment": "detaliile platii",
				"location": "Locul de întâlnire",
				"customLocation": "Locație"
			},
			"buttons": {
				"back": "Întoarce-te",
				"submit": "Trimite",
				"pay": "A plati"
			}
		},
		"calendarView": {
			"changeService": "Schimbare",
			"noAvailability": "Nu e disponibil",
			"noSlotForAppointment": "Niciun slot disponibil pentru această întâlnire. Încercați o întâlnire diferită din opțiunile de sus sau selectați o altă zi.",
			"noSlotForDay": "Nu există disponibilitate în această zi. Încercați o zi diferită de cea din calendarul din stânga."
		},
		"confirmationView": {
			"success": "Succes",
			"defaultMessage": "Veți primi în curând un e-mail de confirmare"
		},
		"minutes": "minute",
		"cellFieldPlaceholder": "Introduceți un număr de mobil valid",
		"alertMessages": {
			"requiredWarning": "Vă rugăm să completați toate elementele necesare.",
			"phoneRequiredMessage": "Este necesar un număr de mobil, vă rugăm să introduceți un număr de mobil valid.",
			"attachmentRequired": "Vă rugăm să încărcați atașamentul necesar.",
			"answerRequired": "Este necesar un răspuns, vă rugăm să introduceți o valoare corectă.",
			"singleAttachment": "Vă rugăm să alegeți un singur atașament.",
			"attachmentSize": "Dimensiunea atașamentului trebuie să fie mai mică de 10 megaocteți.",
			"emptyAttachmentFile": "Fișierul atașat este gol. Vă rugăm să alegeți fișierul corect.",
			"paymentError": "Eroare la procesarea plății. Încercați din nou sau contactați asistența.",
			"savingBookingError": "Ceva n-a mers bine. Vă rugăm să încercați din nou."
		},
		"inputFieldErrorMessages": {
			"name": "Câmpul Nume este obligatoriu",
			"email": "Câmpul E-mail trebuie să fie un e-mail valid",
			"cellNumber": "Introduceți un număr de mobil valid",
			"location": "Câmpul Locație personalizată este obligatoriu"
		}
	},
};

const localization = {
	data() {
		return {
			localizationLabels: localizationLabels
		}
	},
	
	methods: {
		getLocaleText(key, fallbackText) {

			if (!!this.customLabels) {
				if (!_.has(this.customLabels, key)) {
					return fallbackText;
				}

				return _.get(this.customLabels, key)
			}

			// if locale is not set return callback test
			if (!this.activeLocale) {return fallbackText}

			let localeKey = `${this.activeLocale}.${key}`;

			// if key not found for set locale return fallbackText
			if (!_.has(this.localizationLabels, localeKey)) {
				return fallbackText;
			}

			return _.get(this.localizationLabels, localeKey)
		},

		getCurrencySymbol(currency) {
			let currencyDetails = currencies.find((curr) => curr.code == currency);
			let symbol = (currencyDetails && currencyDetails.symbol) ? currencyDetails.symbol : "";
			return symbol;
		}
	},

	computed: {
		activeLocale() {
			let locale = this.calendarData.settings.branding.locale || "en";
			let queryLocale = this.$root.getURLQueryValue("language");

			if (queryLocale && queryLocale in localizationLabels) {
				locale = queryLocale;
			}

			// Fix for old/existing spanish calendars.
			if (locale == "sp") {locale = "es"}

			// Fallback for any other locale
			if (locale in localizationLabels == false) { locale = "en" }

			return locale;
		},

		customLabels() {
			return this.calendarData.settings.branding.localization;
		},

		isLanguageRTL() {
			return this.calendarData.settings.branding.isLanguageRTL || false;
		}
	}
}

export {
  localizationLabels as localizationLabels,
  localization as localization
}
